export default __webpack_public_path__ + "static/media/celular.677b1af1.png";